import {Component} from '@angular/core';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {routesNames} from "@app/app-routing.module";
import {UserSaver} from '@app/core/user/domain/user-saver';
import {
  DeleteAccountBottomSheetComponent
} from '@app/presentation/components/delete-account/delete-account-bottom-sheet/delete-account-bottom-sheet.component';
import {PopupDispatcher} from '@app/presentation/components/errors/popup.dispatcher';
import {AccountViewModel} from "@app/presentation/pages/account/account.view-model";
import {LocalizedRouter} from "@app/presentation/services/localized-router";
import {ShareService} from "@app/presentation/services/share/share.service";
import {Capacitor} from "@capacitor/core";
import {LanguageSelectorService} from "@app/presentation/services/language-selector/language-selector.service";

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent {

  routesNames = routesNames;

  isMobile = this.accountViewModel.getIsMobile();

  isNativeApp = Capacitor.isNativePlatform();

  isLoggedIn$ = this.accountViewModel.getIsLoggedIn();

  versionName$ = this.accountViewModel.getVersionNumber();

  currentDeliveryPoint$ = this.accountViewModel.getCurrentDeliveryPoint();

  menuEntries: { iconKey: string, nameKey: string, url: string[], hide?: boolean }[] = [
    {
      iconKey: 'shopping-cart',
      nameKey: 'usual_purchase',
      url: ['/', routesNames.usualPurchase]
    },
    {
      iconKey: 'order',
      nameKey: 'orders',
      url: ['/', routesNames.orderList]
    },
    {
      iconKey: 'gift',
      nameKey: 'coupons',
      url: ['/', routesNames.coupons]
    },
    {
      iconKey: 'compare',
      nameKey: 'comparator',
      url: ['/', routesNames.comparison]
    },
    {
      iconKey: 'settings',
      nameKey: 'setup_account',
      url: ['/', routesNames.accountConfig],
      hide: this.isMobile
    }
  ]

  configMenuEntries: { iconKey: string, nameKey: string, url: string[] }[] = [
    {
      iconKey: 'user',
      nameKey: 'personal_data',
      url: ['/', routesNames.accountConfig, routesNames.personalData]
    },
    {
      iconKey: 'file',
      nameKey: 'commercial_data',
      url: ['/', routesNames.accountConfig, routesNames.commercialData]
    },
    {
      iconKey: 'poi',
      nameKey: 'delivery_points',
      url: ['/', routesNames.accountConfig, routesNames.deliveryPoints]
    },
    {
      iconKey: 'mail',
      nameKey: 'change_email',
      url: ['/', routesNames.accountConfig, routesNames.changeEmail]
    },
    {
      iconKey: 'lock',
      nameKey: 'change_password',
      url: ['/', routesNames.accountConfig, routesNames.changePassword]
    },
    {
      iconKey: 'card',
      nameKey: 'payment_methods',
      url: ['/', routesNames.accountConfig, routesNames.paymentMethods]
    }
  ]

  user = this.accountViewModel.getUser();

  constructor(
    private accountViewModel: AccountViewModel,
    private popupDispatcher: PopupDispatcher,
    private bottomSheet: MatBottomSheet,
    private userSaver: UserSaver,
    private localizedRouter: LocalizedRouter,
    private shareService: ShareService,
    private languageSelectorService: LanguageSelectorService
  ) {
    this.popupDispatcher.setNotifier(accountViewModel.notifier);
    this.accountViewModel.logoutSucceed$.subscribe({
      next: () => this.navigateToHome()
    });
    this.accountViewModel.deleteAccountSucceed$.subscribe({
      next: () => this.navigateToHome()
    });
    // Reload user whenever a change is notified
    this.userSaver.userChanged$.subscribe({
      next: () => this.user = this.accountViewModel.getUser()
    });
  }

  logout() {
    this.accountViewModel.logout();
  }

  showDeleteAccountBottomSheet() {
    // Open bottom sheet to confirm user's choice
    const bottomSheet = this.bottomSheet.open(DeleteAccountBottomSheetComponent, {
      panelClass: 'ep-bottom-sheet'
    });

    // Save delivery point if user has selected the bottom sheet save option
    bottomSheet.afterDismissed().subscribe({
      next: deleteAccount => {
        if (deleteAccount) {
          this.deleteAccount();
        }
      }});
  }

  shareApp() {
    this.shareService.shareApp();
  }
  
  openLanguageSelector() {
    this.languageSelectorService.openLanguageSelector();
  }

  private navigateToHome() {
    this.localizedRouter.navigate(['/', routesNames.home])
  }

  private deleteAccount() {
    this.accountViewModel.deleteAccount();
  }

}
